import React from "react";
import bus from "../../../admin-bus";
import { MODAL_OPEN } from "../../../action-types";

const trackSelection = ({ option, updateSelection }) => {
  function onEditClick(trackId, e) {
    e.preventDefault();

    window
      .fetch(`/admin/tracks/${trackId}/edit`, {
        credentials: "same-origin",
        headers: {
          "X-Requested-With": "XMLHttpRequest"
        }
      })
      .then(response => {
        response.text().then(data => {
          bus.emit(MODAL_OPEN, { content: data, onSuccess: onEditSuccess });
        });
      })
      .catch(error => {
        console.log("Request failed: ", error);
      });
  }

  function onEditSuccess(data) {
    updateSelection(data.id, { id: data.id, label: data.label });
  }

  return (
    <div className="fba-center" style={{ width: "100%" }}>
      <div style={{ width: "100%" }}>
        <p className="fl-left">{option.label}</p>
        <div className="fl-right">
          <button
            className="button button--xsmall button--primary mr-small"
            onClick={e => onEditClick(option.id, e)}
          >
            Edit track
          </button>
        </div>
      </div>
    </div>
  );
};

export default trackSelection;
